<div
  class="header header-inner-page flex justify-content-between align-items-center"
>
  <div class="flex align-items-center gap-2 pl-2">
    <p-button
      *ngIf="isMobile$ | async"
      icon="pi pi-bars"
      styleClass="p-button-rounded p-button-light p-button-text"
      [style]="{ height: '35px', width: '35px' }"
      (onClick)="showSideMenu.emit(true)"
    ></p-button>
    <img
      class="logo"
      alt="EkapyLogo"
      src="./assets/icons/logo_top.png"
      (click)="onLogoClick()"
    />
    <div>
      <h3 class="text-white">
        <ng-container *ngIf="innerWidth != 0 && innerWidth > 1180">
          {{ environment.appTitleInner }}
          <div>
            <small class="font-light">
              {{ environment.appSubtitle }}
            </small>
          </div>
        </ng-container>
        <ng-container *ngIf="innerWidth != 0 && innerWidth <= 1180">
          {{ environment.appTitleShort }}
        </ng-container>
      </h3>
      <small *ngIf="isStageEnvironment && innerWidth <= 600">
        ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ
      </small>
    </div>
  </div>
  <div class="flex align-items-center mr-2">
    <!--<h4 class="staging-header" *ngIf="isStageEnvironment">ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ</h4>-->
    <div
      class="flex justify-content-center gap-2 text-white"
      style="min-width: 280px"
      *ngIf="isStageEnvironment && innerWidth > 600"
    >
      <p-message
        severity="info"
        styleClass="my‐custom‐msg"
        text="ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ"
      ></p-message>
    </div>
    <p-splitButton text [model]="userMenuItems" (onClick)="onUserButtonClick()">
      <ng-template pTemplate="content">
        <span class="flex items-center font-bold text-0">
          <i class="pi pi-user mr-2"></i>
          <span>{{ innerWidth > 800 ? getNameAndRole() : "" }}</span>
        </span>
      </ng-template>
      <ng-template pTemplate="dropdownicon">
        <i class="pi pi-chevron-down text-0"></i>
      </ng-template>
    </p-splitButton>
  </div>
</div>

<app-user-change-password-form-dialog
  #userChangePasswordFormDialog
  (success)="onChangePasswordSuccess()"
/>

<!-- <hr class="shadow-1" /> -->
